import React, {useState} from 'react';
import {Button} from "react-bootstrap";
import {withTranslation, useTranslation} from "react-i18next";
import {connect, DispatchProp} from "react-redux";
import {ReactComponent as GiftIco} from "../../../../../images/icons/gift.svg";
import {ReactComponent as UserIco} from "../../../../../images/icons/user.svg";
import {ReactComponent as TrophyStarIco} from "../../../../../images/icons/trophy-star.svg";
import handleException from "../../../../services/Api/handleException";
import {RootState} from "../../../../../reducers";
import {getLocation} from "../../../../services/Session/reducer";
import ErrorFormAlertView from "../../../Common/ErrorFormAlertView";
import {useAuth} from "../../../../services/User/auth";
import {getUser} from "../../../../services/User/reducer";
import LoginUserModal from "../../LoginUserModal";
import UserUtils from "../../../../services/User/UserUtils";
import PopupModal from "../../../Modal/PopupModal";

interface OwnProps {
    product: any,
    onSuccess: (voucher?: any) => void
    onHide: () => void;
    onSuccessUserModal?: () => void;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;

function VoucherProductConfirmationModal(props: Props) {
    const [loading, setLoading] = useState(false);
    const [loginModal, setLoginModal] = useState(false);
    const [register, setRegister] = useState(false);
    const [errors, setErrors] = useState<any[]>([]);
    const product = props.product;
    const auth = useAuth();
    const {t} = useTranslation();
    const isLogged = UserUtils.isLogged(props.user);

    const buy = async (product: any) => {
        setLoading(true);
        try {
            const response = await auth.buyVoucher(product.id);
            const vouchers = await auth.syncVouchers();
            await auth.refresh();
            if (vouchers && response) {
                let userVoucher = vouchers.filter(x => x.id === response?.id)[0];
                props.onSuccess(userVoucher);
            } else {
                props.onSuccess(undefined);
            }
            setLoading(false);
        } catch (e: any) {
            const errors = handleException(e);
            setErrors(errors);
            setLoading(false);
        }

    }
    const onShow = () => {
    }

    const handleRegister = () => {
        setRegister(true);
        setLoginModal(true);
    }


    const handleHideLoginModal = () => {
        if(register) {
            setRegister(false);
        }
        setLoginModal(false);
    }

    return <PopupModal
        bodyContent={
            <>
                {isLogged && <ErrorFormAlertView errors={errors}/>}
                {loginModal && (
                    <LoginUserModal page={register ? "REGISTER" : undefined} onHide={handleHideLoginModal} onSuccess={props.onSuccessUserModal}/>
                )}
            </>
        }
        title={isLogged ? product.name : t('modules.voucher.field.log_in_to_buy_voucher.title')}
        description={isLogged ? product?.description : ""}
        show
        onHide={props.onHide}
        onShow={onShow}
        headerIcon={isLogged ? <GiftIco/> : <UserIco/>}
        secondaryButton={!isLogged ? (
            <button
                className={`btn btn-default btn-spinner w-100 ${loading ? " loading disabled" : ""}`}
                onClick={() => setLoginModal(true)}>
                <span className="left spinner-border spinner-border-sm"/>
                {t("common.action.login")}
            </button>
        ) : undefined}
        primaryButton={isLogged ? (
            <Button
                className={`btn btn-spinner btn-primary w-100 ${loading ? " loading disabled" : ""}`}
                onClick={() => buy(product)}>
                <span className="left spinner-border spinner-border-sm"/>
                {product.cost ? `${t("modules.voucher.action.buy_for.title")} ${product.cost} ${t("common.word.points.shortcut")}` : t("modules.voucher.action.collect_for_free.title") }
                <TrophyStarIco className='ms-2'/>
            </Button>
        ) : (
            <button
                className={`btn btn-default btn-spinner w-100 ${loading ? " loading disabled" : ""}`}
                onClick={handleRegister}>
                <span className="left spinner-border spinner-border-sm"/>
                {t("modules.voucher.action.register.title")}
            </button>
        )}
    />
}

const mapStateToProps = (state: RootState) => ({
    location: getLocation(state.session),
    user: getUser(state.user)
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(VoucherProductConfirmationModal));
